var config = null;
export function setConfig(c) {
  config = c;
}
export function getConfig() {
  return config;
}